import { DynamicInputModel, serializable, DynamicFormControlLayout, DynamicInputModelConfig, MATCH_VISIBLE } from '@ng-dynamic-forms/core';
import { PageBuilderItem, PAGE_BUILDER_CODE_COMPONENT } from '../page-builder-components.models';

export enum PAGE_BUILDER_LABEL_TEXT_STYLE {
	NORMAL = 'NORMAL',
	BOLD = 'BOLD'
}
export enum PAGE_BUILDER_LABEL_TEXT_FORMAT {
	NORMAL = 'NORMAL',
	NUMERIC = 'NUMERIC'
}

export interface PageBuilderLabelModelConfig extends DynamicInputModelConfig {
	textStyle: PAGE_BUILDER_LABEL_TEXT_STYLE;
	textFormat: PAGE_BUILDER_LABEL_TEXT_FORMAT;
	binding?: string;
}

export class PageBuilderLabelModel extends DynamicInputModel {
	@serializable() readonly type: string = 'page_builder_label'; 
	textStyle: PAGE_BUILDER_LABEL_TEXT_STYLE;
	textFormat: PAGE_BUILDER_LABEL_TEXT_FORMAT;
	binding?: string;

	constructor(config: PageBuilderLabelModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.textStyle = config.textStyle;
		this.binding = config.binding;
	}

	static initModel(_component: PageBuilderItem): PageBuilderLabelModel { 
		const formModel = new PageBuilderLabelModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE,
			textStyle: _component.TEXT_STYLE as PAGE_BUILDER_LABEL_TEXT_STYLE,
			textFormat: _component.TEXT_FORMAT as PAGE_BUILDER_LABEL_TEXT_FORMAT,
			binding: _component.BINDING,
		});
		return formModel;
	}

	static getProperties() {
        return {
            CODE: PAGE_BUILDER_CODE_COMPONENT.LABEL,
            NAME: 'Label',
            ICON: 'text_fields',
            PROPERTIES: [
                { ID: 'TYPE_COMPONENT', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Type', DEFAULT_VALUE: 'Label', IS_READONLY: true },
                { ID: 'INDEX', CODE: PAGE_BUILDER_CODE_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index' },
                //{ ID: 'DEFAULT_VALUE', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Text', DEFAULT_VALUE: 'Text' },
                { ID: 'BINDING', CODE: PAGE_BUILDER_CODE_COMPONENT.TEXTBOX, LABEL: 'Binding', DEFAULT_VALUE: 'Text' },
                { ID: 'TEXT_STYLE', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Style', DS_DATAS: [
                    { ID: 'NORMAL', VALUE: 'Normal' },
                    { ID: 'BOLD', VALUE: 'Bold' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'NORMAL' },
				{ ID: 'TEXT_FORMAT', CODE: PAGE_BUILDER_CODE_COMPONENT.DROPDOWN, LABEL: 'Format', DS_DATAS: [
                    { ID: 'NORMAL', VALUE: 'Normal' },
                    { ID: 'NUMERIC', VALUE: 'Numérique' },
                ], DS_VALUE_COLUMN_NAME: 'ID', DS_DISPLAY_COLUMN_NAME: 'VALUE', DEFAULT_VALUE: 'NORMAL' },
            ]
        };
    }
}